import styled from 'styled-components';
import DefaultDayPickerInput from 'react-day-picker/DayPickerInput';
import addAlpha from 'utils/addAlpha';

export const Container = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.gray1};
  border-radius: 1rem;
  cursor: pointer;
`;

export const DayPickerStyles = styled.div`
  &&& {
    .DayPicker,
    .DayPicker-wrapper {
      color: ${({ theme }) => theme.colors.navyGreen};
      :focus {
        outline: none;
      }
    }

    .DayPicker-wrapper {
      padding: 0.875rem;
    }

    .DayPicker-Weekday {
      color: ${({ theme }) => theme.colors.greenExtraDark};
    }

    .DayPicker-Body,
    .DayPicker-Day--sunday {
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.navyGreen};
    }

    .DayPicker-Day--today {
      color: ${({ theme }) => theme.colors.greenExtraDark};
    }

    .DayPicker-Day:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(
        .DayPicker-Day--outside
      ):not(.DayPicker-Day--selected):not(.DayPicker-Day--sunday) {
      :hover {
        background-color: ${({ theme }) => theme.colors.greenExtraLight};
      }
    }

    .DayPicker-Day--sunday:not(.DayPicker-Day--selectedRange) {
      :hover {
        background-color: ${({ theme }) => theme.colors.gray5} !important;
      }
    }

    .DayPicker-Day--sunday {
      :hover {
        background-color: ${({ theme }) =>
          theme.colors.greenExtraDark} !important;
      }
    }

    .DayPicker-Day--hoverRange:not(.DayPicker-Day--selectedRange) {
      background-color: ${({ theme }) => theme.colors.gray2} !important;
      border-radius: 0;
    }

    .DayPicker-Day--hoverRangeStart {
      font-weight: 600;
      background-color: ${({ theme }) => theme.colors.greenMedium} !important;
      color: ${({ theme }) => theme.colors.navyGreen};
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    .DayPicker-Day--hoverRangeStart:not(.DayPicker-Day--selectedRange) {
      font-weight: 600;
      background-color: ${({ theme }) => theme.colors.gray4} !important;
      color: ${({ theme }) => theme.colors.navyGreen};
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    .DayPicker-Day--hoverRangeEnd {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }

    .DayPicker-Day--hoverRangeEnd:not(.DayPicker-Day--selectedRange) {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
      background-color: ${({ theme }) => theme.colors.gray4} !important;
    }

    .DayPicker-Day--hoverRange:not(.DayPicker-Day--sunday):not(
        .DayPicker-Day--selectedRange
      ):hover {
      background-color: ${({ theme }) => theme.colors.gray3} !important;
    }

    .DayPicker-Day--hoverRange:not(.DayPicker-Day--sunday):hover {
      background-color: ${({ theme }) => theme.colors.greenLight} !important;
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--start):not(
        .DayPicker-Day--end
      ) {
      background-color: ${({ theme }) => theme.colors.greenExtraLight};
      color: ${({ theme }) => theme.colors.navyGreen};
    }

    .DayPicker-Day--selected {
      border-radius: 0;
    }

    .DayPicker-Day--end,
    .DayPicker-Day--start {
      background-color: ${({ theme }) => theme.colors.greenMedium};
      color: ${({ theme }) => theme.colors.navyGreen};
      font-weight: 600;
    }

    .DayPicker-Day--end:not(.DayPicker-Day--selectedRange),
    .DayPicker-Day--start:not(.DayPicker-Day--selectedRange) {
      background-color: ${({ theme }) => theme.colors.redDark};
      color: ${({ theme }) => theme.colors.navyGreen};
      font-weight: 600;
    }

    .DayPicker-Day--start {
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    .DayPicker-Day--end {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }

    input {
      width: 9.75rem;
      height: 3.5rem;
      border-radius: 1rem;
      padding: 0.9063rem 1.5rem;
      background-color: ${({ theme }) => theme.colors.gray1};
      text-align: center;
      font-size: 1.1875rem;
      line-height: 1.6625rem;
      font-weight: 600;
      border: none;
      color: ${({ theme }) => theme.colors.navyGreen};
      :focus {
        outline: none;
      }
      :hover {
        cursor: pointer;
      }
    }
  }
`;

// @ts-ignore
export const DayPickerInput = styled(DefaultDayPickerInput)``;

export const LastDatePicker = styled.div`
  width: 9.75rem;
  height: 3.5rem;
  border-radius: 1rem;
  padding: 0.9063rem 1.5rem;
  text-align: center;
  font-size: 1.1875rem;
  line-height: 1.6625rem;
  font-weight: 600;
  cursor: pointer;
`;

export const Separation = styled.span`
  width: 0.5831rem;
  margin: 0.7081rem;
  border-bottom: 0.125rem solid
    ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;
